import {
  FETCH_TRIPEVENTS_INIT,
  FETCH_TRIPEVENTS_SUCCESS,
  FETCH_TRIPEVENTS_FAIL,
  FETCH_TRIPBYID_SUCCESS,
  FETCH_TRIPLOG_SUCCESS,
  ADD_DOC_INIT,
  DELETE_DOC_INIT,
} from "./action";

const initialState = {
  processing: false,
  error: false,
  docaddOn: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_TRIPEVENTS_INIT:
      return {
        ...state,
        processing: true,
      };

    case FETCH_TRIPEVENTS_SUCCESS:
      return {
        ...state,
        processing: false,
        tripEventsList: action.payload.rows,
        tripEventsCount: action.payload.count,
      };

    case FETCH_TRIPEVENTS_FAIL:
      return {
        ...state,
        processing: false,
      };

    case FETCH_TRIPBYID_SUCCESS:
      return {
        ...state,
        tripData: action.payload,
      };

    case FETCH_TRIPLOG_SUCCESS:
      return {
        ...state,
        tripLog: action.payload.rows,
      };

    // case ADD_DOC_INIT:
    //   return {
    //     ...state,
    //     docaddOn: [...state.docaddOn, action.value],
    //   };

    case DELETE_DOC_INIT:
      return {
        ...state,
        docaddOn: action.value,
      };
    default:
      return {
        ...state,
      };
  }
}
